// @flow

import alt from '../alt';

class ConfigActions {
	changeValue(field, value) {
		return {
			field: field,
			value: value
		};
	}

	/**
	 * Algatatakse toote laadimine serverist
	 */
	fetchConfig() {
		return {};
	}
	
	/**
	 * Toote laadimine ebaõnnestus
	 */
	fetchConfigFailed(error) {
		return error;
	}
	
	/**
	 * Toode sai laetud
	 */
	fetchConfigDone(data) {
		return data;
	}
	
	/**
	 * Toote salvestamine serverisse
	 */
	saveConfig() {
		return {};
	}
	
	/**
	 * Toote salvestamine ebaõnnestus
	 */
	saveConfigFailed(error) {
		return error;
	}
	
	/**
	 * Toode sai salvestatud
	 */
	saveConfigDone() {
		return null;
	}
}

export default alt.createActions(ConfigActions);
